export default {
  INFO: 'ERROR_INFO',
};
